import React, { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const News = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNews();
  }, []);

  const fetchNews = async () => {
    try {
      const response = await axios.get(`${API}/news`);
      setNews(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Erreur lors du chargement des actualités:', error);
      setLoading(false);
    }
  };

  const getCategoryBadge = (category) => {
    const badges = {
      'info': { class: 'bg-blue-100 text-blue-800', icon: 'ℹ️', label: 'Information' },
      'alerte': { class: 'bg-red-100 text-red-800', icon: '⚠️', label: 'Alerte' },
      'promotion': { class: 'bg-green-100 text-green-800', icon: '🎁', label: 'Promotion' },
      'nouveau': { class: 'bg-purple-100 text-purple-800', icon: '🆕', label: 'Nouveau' }
    };
    return badges[category] || badges['info'];
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }).format(date);
  };

  return (
    <div className="news-page">
      {/* Hero */}
      <section className="bg-gradient-to-r from-[#79c9ea] to-[#5ba8c8] text-white py-16">
        <div className="container-custom text-center">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 uppercase tracking-wide">ACTUALITÉS</h1>
          <p className="text-xl opacity-90">Restez informé de nos dernières nouvelles</p>
        </div>
      </section>

      {/* News List */}
      <section className="section">
        <div className="container-custom">
          {loading ? (
            <div className="flex justify-center py-12">
              <div className="spinner"></div>
            </div>
          ) : news.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-xl text-gray-600">Aucune actualité pour le moment</p>
            </div>
          ) : (
            <div className="max-w-4xl mx-auto space-y-6">
              {news.map((item, index) => {
                const badge = getCategoryBadge(item.category);
                return (
                  <div key={item.id} className="card p-8 fade-in" style={{ animationDelay: `${index * 0.1}s` }}>
                    <div className="flex items-start gap-4">
                      <div className="text-4xl flex-shrink-0">{badge.icon}</div>
                      <div className="flex-grow">
                        <div className="flex flex-wrap items-center gap-3 mb-3">
                          <span className={`badge ${badge.class}`}>{badge.label}</span>
                          <span className="text-sm text-gray-500">📅 {formatDate(item.created_at)}</span>
                        </div>
                        <h2 className="text-2xl font-bold mb-3 text-[#1E3A5F]">{item.title}</h2>
                        <p className="text-gray-700 leading-relaxed whitespace-pre-line">{item.content}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>

      {/* CTA */}
      <section className="section bg-gray-50">
        <div className="container-custom text-center">
          <h2 className="text-3xl font-bold mb-4 text-[#1E3A5F]">Envie de partir en voyage ?</h2>
          <p className="text-xl text-gray-600 mb-8">Découvrez toutes nos destinations disponibles</p>
          <a href="/voyages" className="btn-primary">
            Voir nos voyages
          </a>
        </div>
      </section>
    </div>
  );
};

export default News;